angular.module('wbServices').service('geo', ['$http', ($http) ->
  apiUrl = '//ip-api.com/json/'

  # getProvince(callback)
  #
  # callback: function which is called with the response data as callback(data)
  # returns: result [object] which is populated with the response data asyncronously
  @getProvince = (cb) ->
    result = {}
    $http.get(apiUrl)
      .success((data) ->
        result.province = data['region']
        cb(result)
    )
  @
])

